import { render, staticRenderFns } from "./ChatWidgetInSidebar.vue?vue&type=template&id=1d91f26a"
import script from "./ChatWidgetInSidebar.vue?vue&type=script&lang=js"
export * from "./ChatWidgetInSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../ClientApp/wwwroot/dashboard/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports